"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports["default"] = exports.WaypointTimelineDetails = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _map = require("@nicbase/map");

var _mapping = require("@nicbase/mapping");

var _area = _interopRequireDefault(require("@turf/area"));

var _centerOfMass = _interopRequireDefault(require("@turf/center-of-mass"));

var _circle = _interopRequireDefault(require("@turf/circle"));

var _helpers = require("@turf/helpers");

var _nicbaseConversion = require("nicbase-conversion");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTranslation = require("nicbase-translation");

var _waypointTimelineMarker = _interopRequireDefault(require("./waypoint-timeline-marker"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var mapStateToProps = function mapStateToProps(state) {
  var lengthUnit = state.user.lengthUnit;
  return {
    lengthUnit: lengthUnit
  };
};

exports.mapStateToProps = mapStateToProps;
var mapType = 'osm';

var WaypointTimelineDetails = function WaypointTimelineDetails(_ref) {
  var poiCategory = _ref.poiCategory,
      address = _ref.address,
      poiTerm = _ref.poiTerm,
      radius = _ref.radius,
      lengthUnit = _ref.lengthUnit,
      geometry = _ref.geometry;
  var Icon = (0, _mapping.getPoiCategoryIcon)(poiCategory === null || poiCategory === void 0 ? void 0 : poiCategory.icon);
  var marker = (0, _react.useMemo)(function () {
    if (geometry) {
      var center = (0, _centerOfMass["default"])({
        type: 'Feature',
        geometry: geometry
      });
      return (0, _helpers.point)(center.geometry.coordinates, {
        type: 'Feature',
        geometry: geometry,
        radius: radius
      });
    }

    return null;
  }, [geometry, radius]);

  var _useUserMap = (0, _map.useUserMap)({
    mapType: mapType,
    initialViewport: {
      height: 512,
      width: 512
    }
  }),
      _useUserMap$viewport = _useUserMap.viewport,
      zoom = _useUserMap$viewport.zoom,
      latitude = _useUserMap$viewport.latitude,
      longitude = _useUserMap$viewport.longitude,
      setViewport = _useUserMap.setViewport,
      fitBounds = _useUserMap.fitBounds;

  (0, _react.useEffect)(function () {
    var markerGeometry = marker === null || marker === void 0 ? void 0 : marker.properties.geometry;
    var markerPolygon = markerGeometry && markerGeometry.type === 'Point' ? (0, _circle["default"])(markerGeometry.coordinates, radius, {
      units: 'meters'
    }) : {
      type: 'Feature',
      geometry: markerGeometry
    };

    if (marker) {
      fitBounds({
        type: 'FeatureCollection',
        features: [marker, markerPolygon]
      });
      setViewport(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          zoom: prev.zoom - 2
        });
      });
    }
  }, [fitBounds, marker, radius, setViewport]);

  var computeArea = function computeArea(feat) {
    if (feat && feat.properties.geometry.type === 'Polygon') {
      var polyg = (0, _helpers.polygon)(feat.properties.geometry.coordinates);
      return Math.floor((0, _area["default"])(polyg));
    } else if (feat && feat.properties.geometry.type === 'Point') {
      var pt = (0, _helpers.point)(feat.properties.geometry.coordinates);
      return Math.floor((0, _area["default"])(pt));
    }

    return null;
  };

  var markerArea = computeArea(marker);

  var _ref2 = address !== null && address !== void 0 ? address : {},
      countryCode = _ref2.countryCode,
      street = _ref2.street,
      postalCode = _ref2.postalCode,
      city = _ref2.city;

  var addressCondition = street || postalCode || city;
  var onPoiMarkerClick = (0, _react.useCallback)(function (_ref3) {
    var lat = _ref3.lat,
        lng = _ref3.lng;
    return setViewport(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        latitude: lat,
        longitude: lng,
        zoom: 13
      });
    });
  }, [setViewport]);

  var renderDescription = function renderDescription() {
    if (geometry) {
      if (radius) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "ml-1 mt-4 flex"
        }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Geofence2, {
          style: {
            marginTop: '0.6rem'
          }
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: "ml-2 flex flex-col text-lg "
        }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
          id: "widgets.tourBoard.tooltip.geofence.circle"
        }, function (value) {
          return /*#__PURE__*/_react["default"].createElement("span", null, value, ", ", /*#__PURE__*/_react["default"].createElement(_nicbaseConversion.FormattedUnit, {
            value: radius,
            from: "m",
            to: lengthUnit,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }));
        })));
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "ml-1 mt-4 flex"
      }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Geofence2, {
        style: {
          marginTop: '0.6rem'
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "ml-2 flex flex-col text-lg "
      }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
        id: "widgets.tourBoard.tooltip.geofence.polygon"
      }, function (value) {
        return /*#__PURE__*/_react["default"].createElement("span", null, value, ", ", markerArea, " ", markerArea > 0 && 'm²');
      })));
    }

    return null;
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex"
  }, /*#__PURE__*/_react["default"].createElement(Icon, {
    style: {
      marginTop: '0.6rem'
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "ml-2 flex flex-col text-lg "
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-bold"
  }, poiTerm), /*#__PURE__*/_react["default"].createElement("span", null, poiCategory === null || poiCategory === void 0 ? void 0 : poiCategory.name))), addressCondition && /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-4 flex"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.MapPin, {
    style: {
      height: '15px',
      marginTop: '0.6rem'
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "ml-1 flex flex-col text-lg "
  }, /*#__PURE__*/_react["default"].createElement("span", null, street), /*#__PURE__*/_react["default"].createElement("span", null, countryCode && postalCode ? "".concat(countryCode, "-").concat(postalCode) : postalCode, " ", city))), renderDescription(), geometry && /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-4 h-128 w-128"
  }, /*#__PURE__*/_react["default"].createElement(_map.BaseMap, {
    mapType: mapType,
    zoom: zoom,
    latitude: latitude,
    longitude: longitude,
    height: 512,
    width: 512,
    onViewportChange: setViewport
  }, /*#__PURE__*/_react["default"].createElement(_waypointTimelineMarker["default"], {
    onMarkerClick: onPoiMarkerClick,
    geometry: marker,
    icon: poiCategory === null || poiCategory === void 0 ? void 0 : poiCategory.icon,
    lat: marker.geometry.coordinates[1],
    lng: marker.geometry.coordinates[0]
  }))));
};

exports.WaypointTimelineDetails = WaypointTimelineDetails;
WaypointTimelineDetails.propTypes = {
  geometry: _propTypes["default"].oneOfType([_map.PointShape, _map.PolygonShape]),
  address: _propTypes["default"].shape({
    street: _propTypes["default"].string,
    city: _propTypes["default"].string,
    postalCode: _propTypes["default"].string
  }),
  poiCategory: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    icon: _propTypes["default"].string
  }),
  radius: _propTypes["default"].number,
  lengthUnit: _propTypes["default"].string,
  poiTerm: _propTypes["default"].string
};
WaypointTimelineDetails.defaultProps = {
  geometry: null,
  address: {
    street: '',
    city: '',
    postalCode: ''
  },
  poiCategory: {
    name: null,
    icon: null
  },
  poiTerm: '',
  radius: 0,
  lengthUnit: 'METRIC'
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(WaypointTimelineDetails);

exports["default"] = _default;